import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Header from "../Layout/Header";
import SideBar from "../Layout/SideBar";
import "datatables.net-dt";
import $ from "jquery";
import { baseURL } from "../../axios/common";
import Skeleton from "react-loading-skeleton";

const ListUser = () => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    fetchUsers();
  }, []);

  useEffect(() => {
    if (users.length) {
      $("#Usertable").DataTable();
    }
  }, [users]);

  const fetchUsers = async () => {
    try {
      const response = await axios.get(baseURL + "admin/getUsers?language=en", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      setUsers(response.data.data);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

    // Gender Mapping logic
    const getGenderText = (gender) => {
      switch (gender) {
        case 1:
          return "Male";
        case 2:
          return "Female";
        case 3:
          return "Other";
        default:
          return "N/A";
      }
    };

  return (
    <div>
      <Header />
      <SideBar />
      <main>
        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid"></div>
          </div>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                      <h2 className="card-title">Users</h2>
                      <Link to="/create-user" className="btn btn-primary ms-auto d-blick">Add User</Link>
                    </div>
                    <div className="card-body">
                      <table id="Usertable" className="table table-striped" style={{ width: "100%" }}>
                        <thead>
                          <tr>
                            <th>S.No</th>
                            <th className="img-td">Image</th>
                            <th>User name</th>
                            <th>Email</th>
                            <th>Gender</th>
                            <th>Bio</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {users.length === 0 ? (
                            // Skeleton loaders will be shown while loading the data
                            Array.from({ length: 5 }).map((_, index) => (
                              <tr key={index}>
                                <td><Skeleton width={50} height={20} /></td>
                                <td className="img-td"><Skeleton circle width={50} height={50} /></td>
                                <td><Skeleton width={150} height={20} /></td>
                                <td><Skeleton width={200} height={20} /></td>
                                <td><Skeleton width={100} height={20} /></td>
                                <td><Skeleton width={100} height={20} /></td>
                                <td className="table_action text-center">
                                  <Skeleton width={20} height={20} />
                                  <Skeleton width={20} height={20} />
                                  <Skeleton width={20} height={20} />
                                </td>
                              </tr>
                            ))
                          ) : (
                            // Data rows after loading
                            users.map((user, index) => (
                              <tr key={user.id}>
                                <td>{index + 1}</td>
                                <td className="img-td">
                                  <img src={baseURL + user.profile_path || "assets/img/profile.jpeg"} alt="" />
                                </td>
                                <td>{user.name}</td>
                                <td>{user.email}</td>
                                <td>{getGenderText(user.gender)}</td>
                                <td>{user.bio || "N/A"}</td>
                                <td className="table_action text-center">
                                  <div className="active_td">
                                    <Link to={`/user/${user.id}?language=en`}>
                                      <i className="fa fa-eye" />
                                    </Link>
                                    <Link to="/edit-user">
                                      <i className="fa fa-edit" />
                                    </Link>
                                    <Link to="" className="">
                                      <i className="fa fa-trash" style={{ color: "#f00" }} />
                                    </Link>
                                  </div>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
};

export default ListUser;
